import { Metamodel } from '../base/model';
import { IModel, IAttribute } from '../base/annotation';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { FormatDatasetV2 } from './dataset.v2';
import { format } from '../../shared/utils/string.util';
import { ModelConstants } from '../model-constants';

@Metamodel.model({
    name: ModelConstants.avroDataset,
    display: [
        format(shellStringResources.ModelName_DatasetTemplate, shellStringResources.ModelName_AvroDataset),
        format(shellStringResources.ModelName_DatasetsTemplate, shellStringResources.ModelName_AvroDataset)
    ]
})
export class AvroDataset extends FormatDatasetV2 {
    public static readonly MODEL: IModel;
    public static readonly COMPRESSION_CODEC?: IAttribute;
    public static readonly COMPRESSION_LEVEL?: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'COMPRESSION_CODEC',
        accepts: ['String'],
        display: shellStringResources.ModelName_CompressionCodec
    })
    public compressionCodec?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'COMPRESSION_LEVEL',
        accepts: ['String', 'Int'],
        display: shellStringResources.ModelName_CompressionLabel
    })
    public compressionLevel?: string | number;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
